import { FC, ReactElement, ReactNode, cloneElement, isValidElement } from 'react';

export interface FormControlLabelProps {
  control: ReactElement;
  label: ReactNode;
  className?: string;
  disabled?: boolean;
  value?: string | number | boolean | null;
  'data-testid'?: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  sx?: unknown;
  inputRef?: React.Ref<unknown>;
  name?: string;
}

export const FormControlLabel: FC<FormControlLabelProps> = ({
  control,
  label,
  className,
  disabled,
  value,
  labelPlacement = 'end',
  sx: _sx,
  inputRef,
  name,
  ...props
}) => {
  void _sx;

  const controlNode = isValidElement(control)
    ? cloneElement(control as ReactElement<Record<string, unknown>>, {
        disabled: disabled || Boolean((control.props as { disabled?: boolean }).disabled),
        ...(value !== undefined ? { value } : {}),
        ...(inputRef ? { inputRef } : {}),
        ...(name ? { name } : {}),
      })
    : control;

  const isLabelFirst = labelPlacement === 'start' || labelPlacement === 'top';
  const isVertical = labelPlacement === 'top' || labelPlacement === 'bottom';

  return (
    <label
      {...props}
      className={[
        'inline-flex gap-2 text-ash',
        isVertical ? 'flex-col items-start' : 'items-center',
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {isLabelFirst ? <span>{label}</span> : null}
      {controlNode}
      {!isLabelFirst ? <span>{label}</span> : null}
    </label>
  );
};
